import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import {
	fetchArticleAvailability,
	deleteArticleAvailability
} from 'store/actions';

// Import translation
import { useTranslation } from 'react-i18next';

// Import columns
import { createColumns } from './articles_availability_columns';

// Import components
import { TableTemplate } from 'components/common/templates';

const ArticlesAvailability = ({
	error,
	fetchArticleAvailability,
	deleteArticleAvailability,
	resources,
	match: {
		params: { id }
	}
}) => {
	const { t } = useTranslation();

	return (
		// Dispatch fetchArticleAvailability, deleteArticleAvailability action in articles_availability
		<TableTemplate
			itemId={id}
			error={error}
			type={`articles/${id}/availability`}
			typeText="availability"
			addLinkText={t('availability:buttons.add')}
			resources={resources}
			columns={createColumns}
			fetchResourcesAction={fetchArticleAvailability}
			deleteItemAction={deleteArticleAvailability}
			notificationDeleteSuccessTxt={t(
				'availability:notification.delete_success'
			)}
			notificationDeleteErrorTxt={t('availability:notification.delete_error')}
		></TableTemplate>
	);
};

ArticlesAvailability.propTypes = {
	error: PropTypes.bool.isRequired,
	resources: PropTypes.object.isRequired,
	fetchArticleAvailability: PropTypes.func.isRequired,
	deleteArticleAvailability: PropTypes.func.isRequired,
	match: PropTypes.shape({
		params: PropTypes.shape({ id: PropTypes.string.isRequired })
	})
};

const mapStateToProps = ({ articles: { availability } }) => ({
	error: availability.table.error,
	resources: availability.table
});

export default compose(
	connect(mapStateToProps, {
		fetchArticleAvailability,
		deleteArticleAvailability
	}),
	withRouter
)(ArticlesAvailability);
